import React from "react";

const Success = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
    >
      <path
        d="M32.0837 16.1582V17.4999C32.0819 20.6447 31.0636 23.7046 29.1806 26.2234C27.2977 28.7421 24.6509 30.5847 21.6352 31.4764C18.6195 32.3681 15.3963 32.261 12.4464 31.1712C9.49653 30.0813 6.97795 28.0671 5.26631 25.4289C3.55467 22.7908 2.74169 19.67 2.9486 16.532C3.15552 13.394 4.37125 10.407 6.41448 8.01645C8.45772 5.62587 11.219 3.95982 14.2864 3.26676C17.3539 2.57371 20.5632 2.89079 23.4358 4.17072"
        stroke="#32A75A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.0833 5.8335L17.5 20.4314L13.125 16.0564"
        stroke="#32A75A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Success;
